// extracted by mini-css-extract-plugin
module.exports = {"siteHeaderContainer":"header-module--site-header-container--3JT1j","siteLogo":"header-module--site-logo--PqvGm","siteTitle":"header-module--site-title--3obYe"};